<template>
  <div>
  <v-row class="pt-4 pb-0">
      <v-item-group
        mandatory
        v-model="tapSelect"
        @change="searchFilterData(), page=1"
      >
        <v-container>
          <v-row>
            <v-col cols="12" sm="6" md="6" lg="4">
              <v-item v-slot="{ active, toggle }">
                <v-card
                  :color="active ? '#F3F5FA' : '#F8F9FA'"
                  :class="`pa-0`"
                  outlined
                  style="box-sizing: border-box; border-radius: 16px;"
                  height="72"
                  width="400"
                  @click="toggle"
                >
                <v-row>
                  <v-col cols="4">
                    <v-icon class="ml-5 mt-3" :color="active ? 'white' : '#3776E9'"
                    :style="`border: 0px solid currentColor;
                      background-color: ${active ? '#3776E9' : '#EFF4FD' };
                      border-radius:50%; height: 40px; width: 40px;`"
                    >mdi-format-list-bulleted</v-icon>
                  </v-col>
                  <v-col cols=8 class="mt-0" style="text-align: right; padding-right:30px">
                    <span style="font-weight: 500; font-size: 24px; color: #3776E9;">{{ countAllUser }}</span><br>
                    <span style="font-weight: 500; font-size: 14px; color: #757575;">พนักงานทั้งหมด</span>
                  </v-col>
                </v-row>
                </v-card>
              </v-item>
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="4">
              <v-item v-slot="{ active, toggle }">
                <v-card
                  :color="active ? '#F3F5FA' : '#F8F9FA'"
                  :class="`pa-0`"
                  outlined
                  style="box-sizing: border-box; border-radius: 16px;"
                  height="72"
                  width="400"
                  @click="toggle"
                >
                <v-row>
                  <v-col cols="4">
                    <v-icon class="ml-5 mt-3" :color="active ? 'white' : '#3776E9'"
                    :style="`border: 0px solid currentColor;
                      background-color: ${active ? '#3776E9' : '#EFF4FD' };
                      border-radius:50%; height: 40px; width: 40px;`"
                    >mdi-card-account-details-outline</v-icon>
                  </v-col>
                  <v-col cols=8 class="mt-0" style="text-align: right; padding-right:30px">
                    <span style="font-weight: 500; font-size: 24px; color: #3776E9;">{{ countInnerUser }}</span><br>
                    <span style="font-weight: 500; font-size: 14px; color: #757575;">พนักงานภายใน</span>
                  </v-col>
                </v-row>
                </v-card>
              </v-item>
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="4">
              <v-item v-slot="{ active, toggle }">
                <v-card
                  :color="active ? '#F3F5FA' : '#F8F9FA'"
                  :class="`pa-0`"
                  outlined
                  style="box-sizing: border-box; border-radius: 16px;"
                  height="72"
                  width="400"
                  @click="toggle"
                >
                <v-row>
                  <v-col cols="4">
                    <v-icon class="ml-5 mt-3" :color="active ? 'white' : '#3776E9'"
                    :style="`border: 0px solid currentColor;
                      background-color: ${active ? '#3776E9' : '#EFF4FD' };
                      border-radius:50%; height: 40px; width: 40px;`"
                    >mdi-account-outline</v-icon>
                  </v-col>
                  <v-col cols=8 class="mt-0" style="text-align: right; padding-right:30px">
                    <span style="font-weight: 500; font-size: 24px; color: #3776E9;">{{ countOuterUser }}</span><br>
                    <span style="font-weight: 500; font-size: 14px; color: #757575;">พนักงานภายนอก</span>
                  </v-col>
                </v-row>
                </v-card>
              </v-item>
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="4">
              <v-item v-slot="{ active, toggle }">
                <v-card
                  :color="active ? '#F3F5FA' : '#F8F9FA'"
                  :class="`pa-0`"
                  outlined
                  style="box-sizing: border-box; border-radius: 16px;"
                  height="72"
                  width="400"
                  @click="toggle"
                >
                <v-row>
                  <v-col cols="4">
                    <v-icon class="ml-5 mt-3" :color="active ? 'white' : '#3776E9'"
                    :style="`border: 0px solid currentColor;
                      background-color: ${active ? '#3776E9' : '#EFF4FD' };
                      border-radius:50%; height: 40px; width: 40px;`"
                    >mdi-account-outline</v-icon>
                  </v-col>
                  <v-col cols=8 class="mt-0" style="text-align: right; padding-right:30px">
                    <span style="font-weight: 500; font-size: 24px; color: #3776E9;">{{ countConsultantUser }}</span><br>
                    <span style="font-weight: 500; font-size: 14px; color: #757575;">ที่ปรึกษา</span>
                  </v-col>
                </v-row>
                </v-card>
              </v-item>
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="4">
              <v-item v-slot="{ active, toggle }">
                <v-card
                  :color="active ? '#F3F5FA' : '#F8F9FA'"
                  :class="`pa-0`"
                  outlined
                  style="box-sizing: border-box; border-radius: 16px;"
                  height="72"
                  width="400"
                  @click="toggle"
                >
                <v-row>
                  <v-col cols="4">
                    <v-icon class="ml-5 mt-3" :color="active ? 'white' : '#3776E9'"
                    :style="`border: 0px solid currentColor;
                      background-color: ${active ? '#3776E9' : '#EFF4FD' };
                      border-radius:50%; height: 40px; width: 40px;`"
                    >mdi-account-outline</v-icon>
                  </v-col>
                  <v-col cols=8 class="mt-0" style="text-align: right; padding-right:30px">
                    <span style="font-weight: 500; font-size: 24px; color: #3776E9;">{{ countInternUser }}</span><br>
                    <span style="font-weight: 500; font-size: 14px; color: #757575;">นักศึกษาฝึกงาน</span>
                  </v-col>
                </v-row>
                </v-card>
              </v-item>
            </v-col>
          </v-row>
        </v-container>
      </v-item-group>
  </v-row>
  <v-row class="pt-0">
    <v-col cols="12" sm="6" md="6" lg="4" class="pt-0 pb-0">
      <span class="head-search-text">ชื่อพนักงาน</span>
      <v-autocomplete
        v-model="keywordEmployeeName"
        :items="itemUserName"
        item-text="name"
        item-value="name"
        outlined
        dense
        clearable
        class="mt-2"
        placeholder="ค้นหาได้จาก รหัสพนักงาน ชื่อ-นามสกุล"
        no-data-text="ไม่พบข้อมูล"
        @keyup="getdataEmployee($event.target.value)"
        @change="searchFilterData(), page=1"
        @click:clear="keywordEmployeeName='', page=1"
      >
      <template v-slot:append>
        <img width="18" height="18" src="@/assets/icons/search-icon-2.png" style="cursor: pointer;" @click="searchFilterData(), page=1">
      </template>
      </v-autocomplete>
    </v-col>
    <!-- <v-col cols="12" sm="6" md="6" lg="3" class="pt-0 pb-0">
      <span class="head-search-text">รหัสพนักงาน</span>
      <v-text-field
        v-model="keywordWorkName"
        outlined
        dense
        clearable
        class="mt-2"
        placeholder="ค้นหาได้จากรหัสพนักงาน"
        no-data-text="ไม่พบข้อมูล"
        v-on:keyup.enter="searchFilterData(), page=1"
        @click:clear="keywordWorkName='', searchFilterData(), page=1"
      >
      <template v-slot:append>
        <img width="24" height="24" src="@/assets/icons/search-icon-2.png" style="cursor: pointer;" @click="searchFilterData(), page=1">
      </template>
      </v-text-field>
    </v-col> -->
    <v-col cols="12" sm="6" md="6" lg="3" class="pt-0 d-flex align-end" style="padding-bottom: 15px;">
      <v-menu
        v-model="menu"
        :close-on-content-click="false"
        :nudge-width="200"
        :nudge-top='-10'
        max-width="328"
        left
        offset-y
        origin='left'
        tile
        z-index="0"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            class="text-sub-color head-search-button"
            style="width: 96px; height: 38px;"
            text
            elevation="0"
            v-bind="attrs"
            v-on="on"
          >
            <v-icon left>
              mdi-filter-variant
            </v-icon>
            ตัวกรอง
          </v-btn>
        </template>
        <v-card class="pa-3">
          <v-row class="pt-3">
            <v-col cols="12" class="pt-0 pb-0">
              <span class="head-search-text">บริษัท</span>
              <v-autocomplete
                v-model="keywordCompanyName"
                :items="itemCompanyName"
                item-text="companyFullNameTh"
                item-value="_id"
                outlined
                placeholder="ทั้งหมด"
                no-data-text="ไม่พบข้อมูล"
                class="mt-2"
                dense
                clearable
                @change="getSelectLineofworkDetail(keywordCompanyName)"
                @keyup="getSelectCompany($event.target.value)"
              >
              </v-autocomplete>
            </v-col>
            <!-- <v-col>
              <span class="head-search-text">รูปแบบพนักงาน</span>
              <v-autocomplete
                v-model="keywordContractType"
                :items="filterContract"
                item-text="label"
                item-value="value"
                outlined
                placeholder="ทั้งหมด"
                no-data-text="ไม่พบข้อมูล"
                class="mt-2"
                dense
                clearable
              ></v-autocomplete>
            </v-col> -->
            <!-- <v-col cols="12" class="pt-0 pb-0">
              <span class="head-search-text">แผนก</span>
              <v-autocomplete
                :disabled="keywordCompanyName.length === 0"
                v-model="keywordHeaderName"
                :items="itemHeaderName"
                item-text="orgChartName"
                item-value="_id"
                outlined
                placeholder="ทั้งหมด"
                no-data-text="ไม่พบข้อมูล"
                class="mt-2"
                dense
                clearable
                @keyup="getSelect($event.target.value, 'แผนก',keywordCompanyName)"
              >
              </v-autocomplete>
            </v-col>
            <v-col cols="12" class="pt-0 pb-0">
              <span class="head-search-text">ตำแหน่ง</span>
              <v-autocomplete
                v-model="keywordPosition"
                :items="itemPosition"
                :disabled="keywordHeaderName.length === 0"
                item-text="positionName"
                item-value="positionName"
                outlined
                placeholder="ทั้งหมด"
                no-data-text="ไม่พบข้อมูล"
                class="mt-2"
                dense
                clearable
                @keyup="getSelect($event.target.value, 'ตำแหน่ง',keywordCompanyName)"
              >
              </v-autocomplete>
            </v-col> -->
            <!-- <v-col cols="12" class="pt-0 pb-0">
              <span class="head-search-text">เครือ</span>
              <v-autocomplete
                v-model="keywordGroupCompanyName"
                :items="itemGroupCompanyName"
                item-text="name"
                item-value="_id"
                outlined
                placeholder="ทั้งหมด"
                no-data-text="ไม่พบข้อมูล"
                class="mt-2"
                dense
                clearable
              >
              </v-autocomplete>
            </v-col> -->
          </v-row>
          <v-row class="d-flex mb-1">
            <v-spacer/>
            <v-btn
              class="button-color-outline head-search-button mr-2"
              outlined
              style="width: 60px;"
              elevation="0"
              @click="resetFilterData()"
            >ล้าง</v-btn>
            <v-btn
              class="button-color ml-2 mr-3"
              style="width: 94px;"
              dark
              @click="searchFilterData()"
            >ค้นหา</v-btn>
          </v-row>
        </v-card>
      </v-menu>
    </v-col>
    <v-spacer/>
    <div class="pt-0 d-flex align-end" style="padding-bottom: 15px; padding-right: 12px;">
      <v-btn
        outlined
        class="button-color ra-button-employee"
        dark
        @click="gotocreate()"
      >
        <v-icon left dark color="#fff" size="14px">mdi-plus</v-icon>
        <span class="ra-text-in-button-employee">
          เพิ่มพนักงาน
        </span>
      </v-btn>
      <!-- <v-btn
          outlined
          class="ra-button-employee"
          dark
          @click="gotocreate()"
        >
          <v-icon left dark color="#fff" size="14px">mdi-plus</v-icon>
          <span class="ra-text-in-button-employee">
            เพิ่มพนักงาน
          </span>
        </v-btn> -->
    </div>
  </v-row>
  </div>
</template>

<script>
import { EventBus } from '@/EventBus'
import {
  // getSelectEmployee,
  getUser,
  // getNumberEmployee,
  getSelectCompanyEmployeeNew,
  SelectDataCenterinEditOfficer
} from '@/API/API'

export default {
  name: 'filter-workgroup',
  data () {
    return {
      loading: true,
      keywordWorkName: '',
      keywordEmployeeName: '',
      keywordHeaderName: [],
      keywordCompanyName: [],
      // keywordGroupCompanyName: [], // เครือ
      keywordPosition: [],
      keywordUserName: [],
      keywordContractType: '',
      filterData: {
        name: '',
        header: [],
        companyName: [],
        groupCompany: []
        // limit: 50,
        // page: 1
      },
      filterContract: [],
      itemSmall: ['INET', 'OGS'],
      itemLineWorkName: [],
      itemHeaderName: [],
      itemUserName: [],
      // itemGroupCompanyName: [], // ตัวเลือกเครือ
      itemCompanyName: [],
      itemPosition: [],
      itemsSmallDep: [{
        id: 0,
        value: 0,
        label: 'INET'
      }, {
        id: 1,
        value: 1,
        label: 'MANDALA'
      }],
      countAllUser: 0,
      countInnerUser: 0,
      countOuterUser: 0,
      countConsultantUser: 0,
      countInternUser: 0,
      tapData: ['all', 'inner', 'outer', 'consultant', 'intern'],
      tapSelect: 0,
      menu: false,
      debounce: null
    }
  },
  watch: {
    keywordWorkName: function (val) {
      if (val.length) {
        this.filterData.name = val
        // console.log('Work Name', this.filterData.name)
      }
      // EventBus.$emit('detailCompany', nodeId)
    },
    keywordHeaderName: function (val) {
      if (val.length) {
        this.filterData.managementName = val
      }
      // EventBus.$emit('detailCompany', nodeId)
    }
  },
  created () {
    this.url = process.env.VUE_APP_API_URL
    this.port = process.env.VUE_APP_API_PORT
    this.api = this.url + ':' + this.port
    this.tokenUser = this.$store.state.token
    // this.initSelectData()
    this.getSelectCompany()
    this.getdataEmployee()
    this.getSelectContract()
  },
  mounted () {
    // EventBus.$on('getEmployee', this.getSelectData)
    EventBus.$on('updateTabCount', this.updateTabCount)
  },
  beforeDestroy () {
    // EventBus.$off('getEmployee')
    EventBus.$off('selectEmployee')
    EventBus.$off('updateTabCount')
  },
  methods: {
    // get รายชื่อบริษัท
    async getSelectCompany (value) {
      this.loading = true
      this.itemCompanyName = [] // รายชื่อบริษัท
      var obj = {
        companyId: '',
        companyName: value,
        orgChartName: '',
        positionName: ''
      }
      try {
        const res = await getSelectCompanyEmployeeNew(obj, this.$store.state.token)
        if (res.success) {
          this.itemCompanyName = res.companys
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },
    // เลือกแผนกและตำแหน่ง
    async getSelectLineofworkDetail (id) {
      this.itemPosition = [] // ตำแหน่ง
      this.itemHeaderName = [] // แผนก
      const obj = {
        companyId: id,
        companyName: '',
        orgChartName: '',
        positionName: ''
      }
      try {
        const res = await getSelectCompanyEmployeeNew(obj, this.$store.state.token) // ใหม่
        if (res.success) {
          this.companyItems = res.companys
          this.itemHeaderName = res.orgchart
          this.itemPosition = res.position
          this.loading = false
        }
      } catch (error) {
        console.log(error)
      }
    },
    // พิมพ์ค้นหาแผนกและตำแหน่ง
    async getSelect (value, keyname, companyId) {
      var datafilterall = ''
      if (keyname === 'แผนก') {
        const obj = {
          companyId: companyId,
          companyName: '',
          orgChartName: value,
          positionName: ''
        }
        datafilterall = obj
        // console.log('แผนก', datafilterall)
      } else if (keyname === 'ตำแหน่ง') {
        const obj = {
          companyId: companyId,
          companyName: '',
          orgChartName: '',
          positionName: value
        }
        datafilterall = obj
        // console.log('ตำแหน่ง', datafilterall)
      }
      try {
        const res = await getSelectCompanyEmployeeNew(datafilterall, this.$store.state.token) // ใหม่
        if (res.success) {
          if (keyname === 'แผนก') {
            this.itemHeaderName = res.orgchart // แผนก
            this.itemPosition = res.position // ตำแหน่ง
          } else if (keyname === 'ตำแหน่ง') {
            this.itemPosition = res.position // ตำแหน่ง
          }
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },
    // async initSelectData () {
    //   this.loading = true
    //   const token = this.tokenUser
    //   try {
    //     const res = await getSelectEmployee(token)
    //     if (res.success) {
    //       if (res.result) {
    //         this.itemHeaderName = res.result.orgChartHeader // แผนก
    //         this.itemGroupCompanyName = res.result.groupCompany // ตัวเลือกเครือ
    //         this.itemCompanyName = res.result.company // บริษัท
    //         this.itemPosition = res.result.position // ตำแหน่ง
    //         this.itemUserName = res.result.name
    //       }
    //       EventBus.$emit('selectEmployeeResign', res.result, '', '')
    //     }
    //   } catch (error) {
    //   } finally {
    //   }
    // },
    // check clicktab
    // data user
    async getdataEmployee (value) {
      this.loading = true
      clearTimeout(this.debounce)
      this.debounce = setTimeout(async () => {
        const token = this.tokenUser
        const obj = {
          search: value,
          tab: 'user'
        }
        try {
          const res = await getUser(obj, token)
          if (res.success) {
            if (res.result) {
              this.itemUserName = res.result.users
            }
          }
        } catch (error) {
        }
      }, 400)
    },
    async updateTabCount (value) {
      // const token = this.tokenUser
      // const data = {
      //   tab: 'user'
      // }
      // const res = await getNumberEmployee(data, token)
      this.countAllUser = value.total === -1 ? 0 : value.total
      this.countInnerUser = value.countInner === -1 ? 0 : value.countInner
      this.countOuterUser = value.countOuter === -1 ? 0 : value.countOuter
      this.countConsultantUser = value.countConsultant === -1 ? 0 : value.countConsultant
      this.countInternUser = value.countIntern === -1 ? 0 : value.countIntern
    },
    resetFilterData () {
      this.keywordWorkName = ''
      this.keywordEmployeeName = ''
      this.keywordHeaderName = ''
      this.keywordCompanyName = ''
      this.keywordUserName = ''
      this.keywordPosition = ''
      this.keywordContractType = ''
      this.filterData = {
        employeeId: '',
        name: [],
        companyName: '',
        contractType: '',
        header: '',
        groupCompany: '',
        orgChartHeader: '',
        position: '',
        tab: 'all',
        limit: 15,
        page: 1
      }
      this.tapSelect = 0
      EventBus.$emit('filterEmployee', this.filterData)
    },
    searchFilterData () {
      this.filterData = {
        employeeId: this.keywordWorkName,
        name: this.keywordEmployeeName == null ? [] : this.keywordEmployeeName === '' ? [] : this.keywordEmployeeName,
        companyName: this.keywordCompanyName && this.keywordCompanyName.length === 0 ? [] : this.keywordCompanyName == null ? [] : this.keywordCompanyName === '' ? [] : [this.keywordCompanyName],
        contractType: this.keywordContractType && this.keywordContractType === '' ? '' : this.keywordContractType,
        header: '',
        groupCompany: '', // เครือ
        position: this.keywordPosition === '' ? [] : [this.keywordPosition],
        orgChartHeader: this.keywordHeaderName === '' ? [] : [this.keywordHeaderName],
        limit: 15,
        page: 1,
        tab: this.tapData[this.tapSelect]
      }
      EventBus.$emit('filterEmployee', this.filterData)
    },
    gotocreate () {
      this.$router.push('manageemployee/create')
    },
    async getSelectContract () {
      try {
        const res = await SelectDataCenterinEditOfficer()
        this.filterContract = res.selector.contractType.map((v) => ({
          label: v.type,
          value: v.type
        }))
      } catch (error) {
        console.error(error)
      }
    }
  }
}
</script>

<style>
.v-input__slot {
  align-items: center;
  color: inherit;
  display: flex;
  margin-bottom: 0px !important;
  min-height: inherit;
  position: relative;
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
  width: 100%;
}

.v-text-field.v-text-field--enclosed .v-text-field__details {
  margin-bottom: 0px !important;
}

.v-text-field__details {
  min-height: 0px !important;
}

.theme--light.v-text-field--outlined > .v-input__control > .v-input__slot {
  /* font-family: 'Sarabun', sans-serif; */
  font-family: 'Sarabun', sans-serif !important;
  font-weight: normal;
  font-size: 14px;
}

.v-menu__content {
  font-family: 'Sarabun', sans-serif;
  font-weight: normal;
  font-size: 14px;
}

.filter-chip_department {
  font-family: 'Sarabun', sans-serif;
  font-weight: bold;
  font-size: 14px;
  color: #fff;
}

.filter-title-textfield {
  font-family: 'Sarabun', sans-serif;
  font-weight: normal;
  font-size: 18px;
  color: #000;
}
.ra-button-employee {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 9px 24px;

  /* position: absolute; */
  width: 157px;
  height: 36px;

  /* Color / Primary / Default */

  background: #2BA197;
  border-radius: 4px;
}
.ra-text-in-button-employee {
  font-family: 'Sarabun', sans-serif;
  /* font-weight: normal; */
  font-style: normal;
  font-weight: 200;
  font-size: 14px;
}
</style>
